export const PERSISTENT_TOAST_DURATION = Number.POSITIVE_INFINITY

export const TOAST_TEST_IDS = {
  inviteSuccess: 'invite-success-toast',
  projectCreated: 'project-created-success-toast',
  projectCreatedDismiss: 'project-created-success-toast-dismiss',
  projectKeyDeleted: 'project-key-deleted-success-toast',
  projectDescriptionUpdated: 'project-description-updated-success-toast',
  projectRenamed: 'project-renamed-success-toast',
  feedUrlCopySuccess: 'feed-url-copy-success-toast',
  profilePictureUpdated: 'profile-picture-updated-toast',
} as const

export type ToastTestId = (typeof TOAST_TEST_IDS)[keyof typeof TOAST_TEST_IDS]
